import { required, maxLength } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    diaSemana: { required },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Nome é obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Nome não pode conter mais de 30 caracteres.')
    return errors
  },
  diaSemanaErrors() {
    const errors = []
    if (!this.$v.form.diaSemana.$dirty) return errors
    !this.$v.form.diaSemana.required && errors.push('Este campo é obrigatório.')
    return errors
  },
}
